<script lang="ts">
export default { name: 'PinCreateSuccess' };
</script>

<script lang="ts" setup>
// COMPONENTS
import { GButton } from '@flash-global66/g-button';
import { GImage } from '@flash-global66/g-image';

// COMPOSABLES
import { usePinCreateSuccess } from './usePinCreateSuccess';

import type { PinEmits } from '../../types/pin.type';

const emits = defineEmits<PinEmits>();

const { onContinue } = usePinCreateSuccess(emits);
</script>

<template>
  <div
    class="flex flex-col bg-gray-10 w-full h-full"
    data-test="pin:create-success"
  >
    <div class="flex flex-col justify-center items-center flex-grow">
      <GImage name="check" size="xl" class="mb-md" />
      <p class="text-primary-txt text-8 font-semibold mt-12">
        Tu PIN fue creado con éxito.
      </p>
    </div>
    <section class="flex justify-center mb-8">
      <g-button
        class="px-14"
        @click="onContinue"
        data-test="button:continue"
        >Continuar
      </g-button>
    </section>
  </div>
</template>
